module.exports = __webpack_public_path__ + "static/img/HeNan_lvyouPic.70078230.png";